interface Option<T> {
  value: T;
  label: string;
}

export function renderSortedOptions<T>(
  options: T[],
  getOptionText: (option: T) => string,
  excludeOptions?: T[]
): Option<T>[] {
  return options
    .filter((option) => !excludeOptions?.includes(option))
    .map((option) => ({
      value: option,
      label: getOptionText(option),
    }))
    .sort((a, b) => a.label.localeCompare(b.label));
}
